import { ImageDataLike } from "gatsby-plugin-image";
import React, { FC } from "react";
import About from "./About";
import Contact from "./Contact";
import Footer from "./Footer";
import Home from "./Home";
import Projects from "./Projects";
import Testimonials from "./Testimonials";
import Toolkit from "./Toolkit";
import { Fade as Hamburger } from "hamburger-react";

export interface ImagesProps {
  id: string;
  title: string;
  image: ImageDataLike;
}

export interface TestimonialProps {
  id: string;
  name: string;
  designation: string;
  review: { review: string };
  profileImage: ImageDataLike;
}

export interface ProjectsProps {
  id: string;
  name: string;
  technologies: string[];
  description: { _1: string; _2: string };
  slug: string;
  repo: string;
  image: ImageDataLike;
}

export interface ContentScreenProps {
  images: ImagesProps[];
  testimonials: TestimonialProps[];
  projects: ProjectsProps[];
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ContentScreen: FC<ContentScreenProps> = ({
  images,
  testimonials,
  projects,
  open,
  setOpen,
}) => {
  return (
    <div className="w-full md:w-outerWidth flex flex-col items-center px-5 md:px-10 xl:px-16 2xl:px-28 relative">
      <div className="visible md:hidden fixed top-5 right-5">
        <Hamburger
          color="#0E3E97"
          toggled={open}
          toggle={() => setOpen(!open)}
        />
      </div>
      <Home />
      <About />
      <Toolkit images={images} />
      <Projects projects={projects} />
      <Testimonials testimonials={testimonials} />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContentScreen;
